import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { TableRow, Radio, TableData } from '@ctct/ui-react';

import CurrentPlanBadge from './CurrentPlanBadge';
import RecommendedBadge from './RecommendedBadge';
import { formatCurrency } from '../../utils/pricingUtils';

const defaultProps = {
  visibleTableRow: false,
};

const propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  selectedSMSTierMin: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  selectTierCallback: PropTypes.func.isRequired,
  scrolledIntoView: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  setScrolledIntoView: PropTypes.func.isRequired,
  visibleTableRow: PropTypes.bool,
  t: PropTypes.func.isRequired,
  showCurrentBadge: PropTypes.bool,
  showRecommendedBadge: PropTypes.bool,
};

const SMSTiersTableRow = ({
  min,
  max,
  price,
  selectedSMSTierMin,
  selectTierCallback,
  currency,
  scrolledIntoView,
  setScrolledIntoView,
  isDisabled,
  visibleTableRow,
  t,
  showCurrentBadge,
  showRecommendedBadge,
}) => {
  useEffect(() => {
    // scroll row into view if it's the selected row (recommended is selected by default)
    if (min === selectedSMSTierMin && !scrolledIntoView) {
      const rowMin = document.getElementById(`row-${min}vtr`);

      if (rowMin) {
        rowMin.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        setScrolledIntoView(true);
      }
    }
  }, []);

  return (
    <TableRow id={`row-${min}${visibleTableRow ? 'vtr' : ''}`}>
      <TableData contentType="icon">
        <Radio
          name="sms-tiers"
          disabled={isDisabled}
          id={`sms-tiers-${min}`}
          value={`${min}`}
          checked={min === selectedSMSTierMin}
          onChange={() => {
            selectTierCallback(min, max, price);
          }}
        />
      </TableData>
      <TableData>
        {`${min.toLocaleString()} - ${max > 0 ? max.toLocaleString() : t('sms-plans.unlimited')}`}
        <span className="badge-wrapper">
          {showRecommendedBadge && <RecommendedBadge data-qe-id="sms-recommended-badge" t={t} />}
          {showCurrentBadge && <CurrentPlanBadge data-qe-id="sms-current-plan-badge" t={t} />}
        </span>
      </TableData>
      <TableData>{formatCurrency(currency, price)}</TableData>
    </TableRow>
  );
};

SMSTiersTableRow.propTypes = propTypes;
SMSTiersTableRow.defaultProps = defaultProps;

export default SMSTiersTableRow;
